import { ColorMode } from '../theme/modes.config';
import { useColorModeContext } from '../provider/color-mode-context';

function useColorMode(defaultColorMode?: ColorMode) {
  const { colorMode: colorModeContext, setColorMode } = useColorModeContext();
  const colorMode = defaultColorMode ?? colorModeContext;
  return { colorMode, setColorMode };
}

export { useColorMode };
